import {useState, useEffect} from 'react';
import Icon, { IconType } from '../Icon/Icon';
import { IFormGroup } from "./formTypes";
import { toast } from 'react-toastify';

interface IQuestionWizardProps {
    packet:IFormGroup,
    values:any,
    save:Function,
    close:Function,
}

const QuestionWizard = (props:IQuestionWizardProps)=>{
    let temp = {};
    Object.keys(props.values ?? {}).map(x=>{
        if(props.values[x] && props.values[x] === true || props.values[x] === "true"){
            temp[x] = true;
        }
        else{
            temp[x]= false;
        }
    });
    const [values, setValues] = useState<any>(temp);

const canProcdeedIfHasOne = ()=>{
    if(!props.packet.FormWizardRequireAtLeastOne) return true;
    let hasOne = false;
    props.packet.WizardQuestions?.forEach(x=>{
        if(values[x.PublicId]) hasOne = true;
    });
    return hasOne;
};

    
const save=(closeMe:boolean)=>{
    let v = values;
    props.packet.WizardQuestions?.forEach(x=>{
        if(!v[x.PublicId]) v[x.PublicId] = false;
    })
    if(!canProcdeedIfHasOne()){
        toast.error('You must select at least one option.');
        return;
    }
    props.save(v);
    if(closeMe) props.close();
}
const close = ()=>{
    
    if(!canProcdeedIfHasOne()){
        toast.error('You must select at least one option.');
        return;
    }
    props.close();
};



    return (<>
        <div>
            <br/>
            <div className='flex-between'>
                <h3>{props.packet.Name} Wizard</h3>
            </div>
            Answer the questions below, so we can identify which forms are needed for your packet. Check all that apply.
            <hr/>
            <br/>
            <div className='form-horizontal wizard-body inline-label'>
                {props.packet.WizardQuestions.map((x,i)=>{
                    return (<div key={`wiz-q-${i}`} className='form-group'>
                        <div className='col-sm-12'>
                            <input type='checkbox' 
                            id={`wiz-q-cb-${x.PublicId}`}
                            checked={values[x.PublicId] ?? false}
                            onChange={(e)=>{
                                if(e.target.checked && x.DeselectOthers){
                                    // If this question has DeselectOthers enabled, uncheck all other questions
                                    let newValues = {};
                                    props.packet.WizardQuestions?.forEach(q=>{
                                        newValues[q.PublicId] = q.PublicId === x.PublicId ? true : false;
                                    });
                                    setValues({...newValues});
                                } else if(e.target.checked && !x.DeselectOthers) {
                                    // If checking a regular question, uncheck any questions with DeselectOthers enabled
                                    let newValues = {...values, [x.PublicId]: true};
                                    props.packet.WizardQuestions?.forEach(q=>{
                                        if(q.DeselectOthers && q.PublicId !== x.PublicId){
                                            newValues[q.PublicId] = false;
                                        }
                                    });
                                    setValues(newValues);
                                } else {
                                    // Unchecking any question
                                    setValues({...values,[x.PublicId]:e.target.checked});
                                }
                            }}
                            />
                            <label htmlFor={`wiz-q-cb-${x.PublicId}`} className='control-label'>{x.Question}</label>
                             </div>
                    </div>);
                })              
                }
<br/>
                <div className='form-group'>
                    <div className='col-sm-12'>
                        <button type='button' className='btn btn-secondary' title='Click to save & close.' onClick={()=>{save(true);}}>
                            <Icon type={IconType.save} /> Save & Close
                        </button>
                        <button type='button' className='btn btn-default' title='Click to save.' onClick={()=>{save(false);}}>
                            <Icon type={IconType.save} /> Save
                        </button>
                        <button type='button' className='btn btn-default' title='Click to close.' onClick={()=>{close();}}>
                            <Icon type={IconType.close} /> Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>);
};

export default QuestionWizard;